import React from "react";
import { Box } from "@mui/material";
import SidebarImage, {
  SidebarImageProps,
} from "src/components/NewProductPage/components/SidebarImage";
import { PhotoCaption } from "src/components/NewProductPage/components/RlsNotices";

export interface ProductSidebarProps extends SidebarImageProps {
  isValid?: boolean;
  nonPrescriptionDrug?: boolean;
  catalogBrandSlug?: string;
  picMatch?: string | null;
}

const CatalogProductSidebar: React.FC<ProductSidebarProps> = ({
  name,
  imgSrc,
  picMatch,
}) => {
  return (
    <Box mr={2.5} position="sticky" top="127px" left="0px">
      <SidebarImage name={name} imgSrc={imgSrc} />
      <PhotoCaption picMatch={picMatch} />
    </Box>
  );
};

export default CatalogProductSidebar;
